import dayjs from "dayjs";

export const APP_NAME = "Your Brand Name";

export const cx = (...classes: string[]) => {
  return classes.filter(Boolean).join(" ");
};

export const formatDate = (date: string) => {
  return dayjs(date).format("DD MMM YYYY");
};

export const formatCurrency = (num?: number) => {
  const usdCurrencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });
  return usdCurrencyFormatter.format(num || 0);
};

export const summarizeCurrency = (num: number) => {
  const usdCurrencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    notation: "compact",
  });
  return usdCurrencyFormatter.format(num);
};

export const capitalize = (s: string) => {
  return s ? s.charAt(0).toUpperCase() + s.substring(1).toLowerCase() : "";
};
export const titleCase = (str: string) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
    .join(" ");
};

export const API_ENDPOINT = "https://admin.travelicious.club";
